import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ion-text-center" }
const _hoisted_2 = {
  key: 1,
  class: "ion-text-center"
}

import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Autoplay } from "swiper/modules";
import { ImageDescriptor } from "@/types";
import { PropType } from "vue";
import { getCurrentLanguage, getCustomMessage, isFile } from "@/utils";
import { IonImg } from "@ionic/vue";

// Use `string` for module/imported image references instead of NodeRequire,
// because `NodeRequire` may not exist in browser runtime and causes
// "NodeRequire is not defined" on some machines when the bundle is run.

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCarousel',
  props: {
  images: {
    // Accept ImageDescriptor objects, File objects (from file inputs),
    // or plain strings (URL or webpack/rollup require() import result).
    type: Array as PropType<(ImageDescriptor | File | string)[]>,
    required: true,
  },
  images_names: {
    type: Array as PropType<string[]>,
  },
  show_name: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    default: "150px",
  },
  width: {
    type: String,
    default: "auto",
  },
},
  setup(__props) {

const props = __props;

const isImageDescriptor = (
  image: ImageDescriptor | File | string
): image is ImageDescriptor =>
  image instanceof Object && "name" in image && "url" in image;
const getName = (idx: number) =>
  props.images_names && props.images_names.length > idx
    ? props.images_names[idx]
    : props.images.length > idx &&
      (isFile(props.images[idx]) || isImageDescriptor(props.images[idx]))
    ? props.images[idx].name
    : "Image";



const language = getCurrentLanguage();
const modules = [Navigation, Autoplay];

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (__props.images.length > 1)
    ? (_openBlock(), _createBlock(_unref(Swiper), {
        key: 0,
        modules: modules,
        "slides-per-view": 1,
        navigation: "",
        autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image, index) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (__props.show_name)
                    ? (_openBlock(), _createBlock(_component_ionic_element, {
                        key: 0,
                        element: _unref(getCustomMessage)(getName(index), getName(index))
                      }, null, 8, ["element"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonImg), {
                    src: 
            isImageDescriptor(image)
              ? image.url
              : _unref(isFile)(image)
              ? require('@/assets/' + _unref(language) + '_to_load.png')
              : image
          ,
                    alt: getName(index),
                    style: _normalizeStyle({
            height: __props.height,
            width: __props.width,
          })
                  }, null, 8, ["src", "alt", "style"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : (__props.images.length == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.show_name)
            ? (_openBlock(), _createBlock(_component_ionic_element, {
                key: 0,
                element: _unref(getCustomMessage)(getName(0), getName(0))
              }, null, 8, ["element"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonImg), {
            src: 
        isImageDescriptor(__props.images[0])
          ? __props.images[0].url
          : _unref(isFile)(__props.images[0])
          ? require('@/assets/' + _unref(language) + '_to_load.png')
          : __props.images[0]
      ,
            alt: getName(0),
            style: _normalizeStyle({
        height: __props.height,
        width: __props.width,
      })
          }, null, 8, ["src", "alt", "style"])
        ]))
      : _createCommentVNode("", true)
}
}

})